"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var NewsletterForm = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(NewsletterForm, _window$AbstractEleme);

    var _super = _createSuper(NewsletterForm);

    _createClass(NewsletterForm, null, [{
      key: "NEWSLETTER_SUBSCRIBED_COOKIE",
      get: function get() {
        return "newsletter_subscribed";
      }
    }]);

    function NewsletterForm(id, options) {
      var _this;

      _classCallCheck(this, NewsletterForm);

      _this = _super.call(this, id, options);
      _this.$submit = _this.$domElement.find('button[type="submit"]');
      _this.$email = _this.$domElement.find('[name="EMAIL"]');
      _this.$successAlert = _this.$domElement.find('.alert.alert-success');
      _this.$warningAlert = _this.$domElement.find('.alert.alert-warning');
      _this.$errorAlert = _this.$domElement.find('.alert.alert-danger');
      return _this;
    }

    _createClass(NewsletterForm, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        var validatorRules = {
          'email': {
            required: true,
            email: true
          }
        };
        this.$domElement.validate({
          rules: validatorRules,
          errorElement: 'small',
          errorClass: 'form-text',
          errorPlacement: function errorPlacement(error, element) {
            error.insertAfter(_this2.$domElement.find(".input-group-btn"));
          },
          highlight: function highlight(element) {
            $(element).closest('.form-group').addClass('form-error');
          },
          unhighlight: function unhighlight(element) {
            $(element).closest('.form-group').removeClass('form-error');
          },
          submitHandler: function submitHandler(form) {
            try {
              _this2._killAJAXRequest();

              _this2.AJAXrequest = $.ajax({
                type: "POST",
                url: _this2.$domElement.attr("action"),
                data: _this2.$domElement.serialize(),
                dataType: 'json',
                crossDomain: true,
                success: function success(data) {
                  window.Cookies.set(window.NewsletterForm.NEWSLETTER_SUBSCRIBED_COOKIE, 'true');

                  _this2.showAlert(_this2.$successAlert, true);
                },
                error: function error(jqXHR, textStatus, errorThrown) {
                  if (jqXHR.status == 200) {
                    window.Cookies.set(window.NewsletterForm.NEWSLETTER_SUBSCRIBED_COOKIE, 'true');

                    if (jqXHR.responseText.includes("processata con successo")) {
                      /* already subscribed */
                      _this2.showAlert(_this2.$warningAlert, true);
                    } else {
                      /* succesfully subscribed */
                      _this2.showAlert(_this2.$successAlert, true);
                    }

                    _this2.reset();
                  } else {
                    _this2.showAlert(_this2.$errorAlert, false);

                    _this2.reset();
                  }
                }
              });
            } catch (e) {
              _this2.showAlert(_this2.$errorAlert, false);

              _this2.reset();
            }
          }
        });

        _get(_getPrototypeOf(NewsletterForm.prototype), "init", this).call(this);
      }
    }, {
      key: "reset",
      value: function reset() {
        this.$domElement[0].reset();
      }
    }, {
      key: "showAlert",
      value: function showAlert($alert, reset) {
        var _this3 = this;

        var tl = new window.TimelineMax({
          onComplete: function onComplete() {
            window.TweenMax.set($alert, {
              clearProps: "all"
            });
          }
        });
        tl.fromTo($alert, 0.65, {
          display: "flex",
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: window.Expo.easeOut,
          onComplete: function onComplete() {
            if (reset) _this3.reset();
          }
        });
        tl.to($alert, 0.55, {
          autoAlpha: 0,
          ease: window.Expo.easeInOut
        }, "+=5");
      }
    }, {
      key: "_killAJAXRequest",
      value: function _killAJAXRequest() {
        if (this.AJAXrequest) {
          this.AJAXrequest.abort();
          this.AJAXrequest = null;
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this._killAJAXRequest();

        this.$submit = null;
        this.$email = null;

        _get(_getPrototypeOf(NewsletterForm.prototype), "dispose", this).call(this);
      }
    }]);

    return NewsletterForm;
  }(window.AbstractElement);

  window.NewsletterForm = NewsletterForm;
})(window);
